import {combineReducers} from 'redux';
import types from './types';

// 選択データ
const selections = (state = null, action) => {
  switch (action.type) {
    case types.SAVE_SELECTED_ITEMS:
      let list = state ? state : [];
      let newList = list.filter((data) =>
        data.screenId != action.screenId);
      newList.push({
        screenId: action.screenId,
        compareKey: action.compareKey,
        selectedItems: action.selectedItems,
      });
      return newList;
    default:
      return state;
  }
};

// スクロール位置
const scrollPosition = (state = null, action) => {
  switch (action.type) {
    case types.SAVE_SCROLL_POSITION:
      let list = state ? state : [];
      let newList = list.filter((data) =>
        data.screenId != action.screenId);
      newList.push({
        screenId: action.screenId,
        scrollPosition: action.scrollPosition,
      });
      return newList;
    default:
      return state;
  }
};

const reducer = combineReducers({
  selections,
  scrollPosition,
});

export default reducer;
